function getCompanies(state) {
  return state?.entityBrandings?.companies || [];
}

export function getCompany(state) {
  const companies = getCompanies(state);
  const company = companies.find(({ type }) => type === 'COMPANY');
  const division = companies.find(({ type }) => type === 'DIVISION');
  return division || company;
}

export function entityBrandings(state) {
  return state?.entityBrandings;
}

export function getCompanyName(state) {
  const companies = getCompanies(state);
  const company = companies.find(({ type }) => type === 'COMPANY');
  const division = companies.find(({ type }) => type === 'DIVISION');
  const companyName = company?.displayName || company?.name || 'Updater';
  const divisionName = division?.displayName || division?.name;
  return divisionName || companyName;
}

export function disclaimer(state) {
  return state?.disclaimer;
}
export function journey(state) {
  return state?.journey;
}
export function website(state) {
  const companies = getCompanies(state);
  return companies[0]?.website;
}
export function phone(state) {
  const companies = getCompanies(state);
  return companies[0]?.phone;
}

export function brandingDisplayName(state) {
  return state?.entityBrandings?.whiteLabel?.displayName || 'Updater';
}
